import React, { useEffect, useState } from 'react';
import api from '../utils/api';

export default function CentralDestination({ section = 'users', account = false }: { section?: string; account?: boolean }) {
  const [href, setHref] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    if (account) {
      const target = `/api/portal/account?returnUrl=${encodeURIComponent(window.location.origin + '/dashboard')}`;
      setHref(target);
      window.location.replace(target);
      return;
    }
    let active = true;
    api.get('/api/portal/sidebar-config').then(response => {
      const service = response.data.data?.services?.find((item: { slug: string }) => item.slug === 'portal-admin');
      const base = service?.baseUrl;
      if (!base) throw new Error('missing');
      const target = new URL(`${base.replace(/\/$/, '')}/${section}`, window.location.origin);
      if (!['http:', 'https:'].includes(target.protocol)) throw new Error('invalid');
      if (active) { setHref(target.toString()); window.location.replace(target.toString()); }
    }).catch(() => { if (active) setError('Не удалось получить адрес общей админки. Обновите страницу или откройте её в меню портала.'); });
    return () => { active = false; };
  }, [account, section]);
  return <section className="u2-card"><div className="u2-cardInner"><h1 className="u2-title">{account ? 'Единый профиль портала' : 'Общая админка портала'}</h1><p>{error || 'Переходим в центральное управление…'}</p>{href && <a className="u2-btn is-primary" href={href}>Продолжить</a>}</div></section>;
}
